import {createAsyncThunk} from '@reduxjs/toolkit';

import {
    fetchAisSignatories,
    TFetchAisSignatoriesArgs,
    putAisSignatories,
    TPutAisSignatoriesArgs,
} from 'store/slices/directories-company-slice/directories-company-slice-api';
import {DIRECTORIES_COMPANY_SLICE} from 'store/slices/directories-company-slice/directories-company-slice-constants';
import {TAisSignatoryDto} from 'store/slices/directories-company-slice/directories-company-slice-types';

export const loadAisSignatoriesByOrgId = createAsyncThunk<
    TAisSignatoryDto[], TFetchAisSignatoriesArgs
    >(
        `${DIRECTORIES_COMPANY_SLICE}/loadAisSignatoriesByOrgId`,
        async (arg, {rejectWithValue}) => {
            try {
                const response = await fetchAisSignatories(arg);
                if (response.status !== 200) {
                    return rejectWithValue('При загрузке данных произошла ошибка');
                }

                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const uploadAisSignatoriesByOrgId = createAsyncThunk<
    string, TPutAisSignatoriesArgs
    >(
        `${DIRECTORIES_COMPANY_SLICE}/uploadAisSignatoriesByOrgId`,
        async (arg, {rejectWithValue}) => {
            try {
                const response = await putAisSignatories(arg);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );
